// @tennis-matches/services/api/get-api-base-url
// Leer = same-origin (Vite-Proxy lokal, Cloudflare Functions auf Pages).

function __asStr(v) {
  return String(v ?? "").trim();
}

function __normalizeApiBase(url) {
  return __asStr(url).replace(/\/+$/, "");
}

/**
 * Basis-URL für Express-/API-Routen (`/api/*`).
 * Web Prod: leer → same-origin (Cloudflare Function proxy oder eigener Host).
 * Mobile: `globalThis.__TTB_ENV__.API_BASE_URL`.
 */
export function getApiBaseUrl() {
  try {
    const g = globalThis.__TTB_ENV__ || {};
    const fromRuntime = __normalizeApiBase(g.API_BASE_URL);
    if (fromRuntime) return fromRuntime;
  } catch (_) {}

  try {
    if (
      typeof import.meta !== "undefined" &&
      import.meta.env?.VITE_API_BASE_URL
    ) {
      return __normalizeApiBase(import.meta.env.VITE_API_BASE_URL);
    }
  } catch (_) {}

  return "";
}

/**
 * Basis-URL für Full-Page-Navigation zu `/api/*` (z. B. PayPal-Redirect).
 * Vite/React behandeln `/api/...` sonst als SPA-Route „api“ ohne Proxy-Redirect.
 *
 * @returns {string} z. B. `http://localhost:5174` oder leer (= same-origin)
 */
export function getApiBaseUrlForNavigation() {
  const explicit = getApiBaseUrl();
  if (explicit) return explicit;

  try {
    if (typeof window !== "undefined" && window.location?.hostname) {
      const host = __asStr(window.location.hostname);
      const port = __asStr(window.location.port);
      if (
        (host === "localhost" || host === "127.0.0.1") &&
        (port === "3000" || port === "5173" || port === "3009")
      ) {
        return "http://localhost:5174";
      }
    }
  } catch (_) {
    // ignore
  }

  return "";
}

/**
 * @param {string} path - z. B. `/api/trainerstunden/contact-invites/send`
 */
export function resolveApiUrl(path) {
  const p = __asStr(path);
  const normalized = p.startsWith("/") ? p : `/${p}`;
  // Browser: immer same-origin /api (Vite-Proxy, Pages-Function) — vermeidet CORS/401 ohne Bearer.
  try {
    if (typeof window !== "undefined" && window.location?.origin) {
      return normalized;
    }
  } catch (_) {
    // ignore
  }
  const base = getApiBaseUrl();
  return base ? `${base}${normalized}` : normalized;
}
